"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iframeNormalizer = void 0;
/**
 * normalizador del modulo COMPONENT_TYPE
 * @param {object} fields
 * @returns
 */
const iframeNormalizer = (data) => {
    try {
        let res = {};
        const { fields } = data;
        res.src = fields === null || fields === void 0 ? void 0 : fields.src;
        res.type = fields === null || fields === void 0 ? void 0 : fields.tipo;
        res.titleSEO = fields === null || fields === void 0 ? void 0 : fields.titleSEO;
        res.title = fields === null || fields === void 0 ? void 0 : fields.title;
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.iframeNormalizer = iframeNormalizer;
exports.default = exports.iframeNormalizer;
//# sourceMappingURL=index.js.map